export const SET_TABLE_SCHEDULED_PAYMENT = "SET_TABLE_SCHEDULED_PAYMENT"
